module.exports = __webpack_public_path__ + "img/statement.64ab9413.svg";